import {
    TextInput,
    Anchor,
    Paper,
    Title,
    Text,
    Container,
    Button,
} from '@mantine/core';
import { useEffect, useState } from 'react';
import axios from '../../api/axios.js'

const USER_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const RESET_URL = '/password';

export default function ForgotPasswordDomain() {

    const [user, setUser] = useState('');
    const [validName, setValidName] = useState(false);

    const [resiWeb, setResiWeb] = useState('');

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        setValidName(USER_REGEX.test(user));
    }, [user])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search || "");
        const domainParam = params.get("domain");
        if (domainParam && !resiWeb) {
            setResiWeb(domainParam);
        }
    }, [resiWeb]);

    useEffect(() => {
        setErrMsg('');
    }, [user, resiWeb])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const v1 = USER_REGEX.test(user);
        if (!v1) {
            setErrMsg("Invalid Entry");
            return;
        }

        const requestedDomain = String(resiWeb || "").trim().toLowerCase();
        if (!requestedDomain) {
            setErrMsg("Domain is required");
            return;
        }

        await axios.post(
            RESET_URL,
            JSON.stringify({ user, resiWeb: requestedDomain }),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
        );

        setSuccess(true);
    }

    return (
        <>
            {success ? (
                <Container size={420} my={40}>
                    <Title ta="center">
                        Request successful! We have sent the password reset link to your Email address.
                    </Title>
                    <Text c="dimmed" size="sm" ta="center" mt={5}>
                        Go to the login page{' '}
                        <Anchor size="sm" component="a" href="/login">
                            Login
                        </Anchor>
                    </Text>
                </Container>
            ) : (
                <Container size={420} my={40}>
                    <Title ta="center">
                        Password Reset
                    </Title>
                    <Text c="dimmed" size="sm" ta="center" mt={5}>
                        Back to{' '}
                        <Anchor size="sm" component="a" href="/login">
                            Login
                        </Anchor>
                    </Text>

                    <form onSubmit={handleSubmit}>
                        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
                            <TextInput
                                label="Email"
                                placeholder="name@name.com"
                                required
                                value={user}
                                onChange={(e) => setUser(e.target.value)} />

                            <TextInput
                                mt="md"
                                label="Domain"
                                placeholder="your-subdomain.example.com"
                                required
                                value={resiWeb}
                                onChange={(e) => setResiWeb(e.target.value)}
                            />

                            <Button type="submit" variant="outline" color="resirent" fullWidth mt="lg" disabled={!validName || !String(resiWeb || "").trim()}>
                                Request Password Change
                            </Button>

                        </Paper>

                    </form>
                </Container >
            )}
        </>
    );
}
